/** MUI */
import {
    MenuItem,
} from "@mui/material";

/** Components */
import BaseSelect2 from "./BaseSelect2";
import Countries from "../Js/countries";

export default function CustomFilledSelectCountries(props) {
    const { id, label, value, onChange, error, disabled, required, name, ...rest } = props;

    const allCountries = [...Countries];
    allCountries.sort((a, b) => {
        if (sessionStorage.getItem("lng") === "en") {
            return a.name_en.localeCompare(b.name_en);
        } else {
            return a.name_es.localeCompare(b.name_es);
        }
    });

    return (
        <BaseSelect2
            fullWidth
            required={required}
            error={error}
            disabled={disabled ?? false}
            id={id}
            name={name}
            value={value}
            onChange={onChange}
            label={label}
            {...rest}
        >
            {allCountries.map((option) => (
                <MenuItem key={"country_" + option.code} value={option.code}>
                    {sessionStorage.getItem("lng") === "en" ? option.name_en : option.name_es}
                </MenuItem>
            ))}
        </BaseSelect2>
    );
}
